import React, { useEffect, useState } from 'react';
import { MenuIcon, XIcon } from 'lucide-react';
import { Logo } from './Logo';
export function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 10);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const navLinks = [{
    name: 'Features',
    href: '#features'
  }, {
    name: 'How It Works',
    href: '#how-it-works'
  }, {
    name: 'Pricing',
    href: '#pricing'
  }, {
    name: 'FAQ',
    href: '#faq'
  }];
  return <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-white/90 backdrop-blur-md shadow-sm border-b border-slate-200 py-3' : 'bg-transparent py-5'}`} data-id="element-176">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-177">
        <div className="flex justify-between items-center" data-id="element-178">
          <a href="#" className="focus:outline-none focus-visible:ring-2 focus-visible:ring-brand-teal rounded-md" data-id="element-179">
            <Logo data-id="element-180" />
          </a>

          {/* Desktop Nav */}
          <nav className="hidden md:flex items-center gap-8" data-id="element-181">
            <ul className="flex gap-6" data-id="element-182">
              {navLinks.map(link => <li key={link.name} data-id="element-183">
                  <a href={link.href} className="text-sm font-medium text-slate-600 hover:text-brand-teal transition-colors focus:outline-none focus-visible:ring-2 focus-visible:ring-brand-teal rounded-sm" data-id="element-184">
                    {link.name}
                  </a>
                </li>)}
            </ul>
            <button className="bg-brand-teal hover:bg-brand-dark text-white px-5 py-2.5 rounded-lg font-medium text-sm transition-colors shadow-sm focus:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:ring-brand-teal" data-id="element-185">
              Sign Up Free
            </button>
          </nav>

          {/* Mobile Menu Toggle */}
          <button className="md:hidden p-2 text-slate-600 hover:text-brand-teal focus:outline-none" onClick={() => setMobileMenuOpen(!mobileMenuOpen)} aria-label="Toggle menu" data-id="element-186">
            {mobileMenuOpen ? <XIcon className="w-6 h-6" data-id="element-187" /> : <MenuIcon className="w-6 h-6" data-id="element-188" />}
          </button>
        </div>
      </div>

      {/* Mobile Nav */}
      {mobileMenuOpen && <div className="md:hidden absolute top-full left-0 right-0 bg-white border-b border-slate-200 shadow-lg py-4 px-4 flex flex-col gap-4" data-id="element-189">
          <ul className="flex flex-col gap-4" data-id="element-190">
            {navLinks.map(link => <li key={link.name} data-id="element-191">
                <a href={link.href} className="block text-base font-medium text-slate-700 hover:text-brand-teal" onClick={() => setMobileMenuOpen(false)} data-id="element-192">
                  {link.name}
                </a>
              </li>)}
          </ul>
          <button className="w-full bg-brand-teal text-white px-5 py-3 rounded-lg font-medium text-base mt-2" data-id="element-193">
            Sign Up
          </button>
        </div>}
    </header>;
}